module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('joi-form', {
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema,
      "error": _vm.formError
    },
    on: {
      "formdataready": _vm.save
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns small-centered"
  }, [_c('span', {
    attrs: {
      "data-form-error-callout": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Név:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.displayName),
      expression: "data.displayName"
    }],
    attrs: {
      "type": "text",
      "name": "displayName"
    },
    domProps: {
      "value": (_vm.data.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "displayName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          E-mail:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.email),
      expression: "data.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.data.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Hozzáférés:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.accessGranted),
      expression: "data.accessGranted"
    }],
    attrs: {
      "id": "accessGranted-yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.data.accessGranted, true)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "accessGranted", true)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "accessGranted-yes"
    }
  }, [_vm._v("Engedélyezve")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.accessGranted),
      expression: "data.accessGranted"
    }],
    attrs: {
      "id": "accessGranted-no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.data.accessGranted, false)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "accessGranted", false)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "accessGranted-no"
    }
  }, [_vm._v("Tiltva")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "accessGranted"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Szerepkör:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.role),
      expression: "data.role"
    }],
    attrs: {
      "id": "role-user",
      "type": "radio",
      "value": "user"
    },
    domProps: {
      "checked": _vm._q(_vm.data.role, "user")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "role", "user")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "role-user"
    }
  }, [_vm._v("Vendég")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.role),
      expression: "data.role"
    }],
    attrs: {
      "id": "role-admin",
      "type": "radio",
      "value": "admin"
    },
    domProps: {
      "checked": _vm._q(_vm.data.role, "admin")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "role", "admin")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "role-admin"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "role"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Jelszó:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Jelszó még egyszer:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.passwordCheck),
      expression: "data.passwordCheck"
    }],
    attrs: {
      "type": "password",
      "name": "passwordCheck"
    },
    domProps: {
      "value": (_vm.data.passwordCheck)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "passwordCheck", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), (_vm.data.id) ? _c('button', {
    staticClass: "button alert trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Törlés")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Vissza")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56c8bbc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/Edit.vue
// module id = 477
// module chunks = 2